import  {GiftCard, GiftCardError, giftCardUserI } from './Interface';
export enum GiftCardTypes {
    LOAD_GIFTCARD = 'LOAD/GIFTCARD',
    LOAD_ACTIVATE_GIFTCARD = 'LOAD/ACTIVATE/GIFTCARD',
    LOADING_GIFTCARD= 'LOADING?GIFTCARD',
    GIFTCARD_ERROR= 'GIFTCARD/ERROR',
    ADD_USER="ADD/USER"
}

interface GiftCard_Loaded{
    type: typeof GiftCardTypes.LOAD_GIFTCARD,
    payload:{
        data:GiftCard
    }
}
interface errorsLoaded {
    type: typeof GiftCardTypes.GIFTCARD_ERROR,
    payload:{
        errors: GiftCardError
    }
}

interface addGiftCardUserI {
    type: typeof GiftCardTypes.ADD_USER,
    payload:{
        data: giftCardUserI
    }
}
interface activateGiftCard{
    type: typeof GiftCardTypes.LOAD_ACTIVATE_GIFTCARD
}

export type ResourceTypeAction = GiftCard_Loaded | errorsLoaded | addGiftCardUserI | activateGiftCard;

